import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=7ba97c06&scoped=true&"
import script from "./photoList.vue?vue&type=script&lang=ts&"
export * from "./photoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba97c06",
  null
  
)

export default component.exports